import Svg, { Path } from 'react-native-svg'
import { COLORS } from '../../lib/brand'

interface AppleIconProps {
  size?: number
  color?: string
}

/**
 * Apple Inc. logo mark for Sign in with Apple buttons.
 * Follows Apple Human Interface Guidelines for third-party usage.
 * Path from the official Apple brand SVG, mapped to 24×24 viewBox.
 */
export function AppleIcon({ size = 16, color = COLORS.black }: AppleIconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.51-3.23 0-1.44.64-2.2.45-3.06-.4C3.79 16.17 4.36 9.54 8.82 9.28c1.28.07 2.16.72 2.91.78.99-.2 1.94-.78 3-.84 1.28-.1 2.25.38 2.88 1.17-2.63 1.58-2.01 5.05.57 6.02-.47 1.24-.83 1.86-1.58 2.95-.58.84-1.39 1.83-2.55 1.92zm-4.67-11.6C12.16 6 14 4.1 16.43 3.72c.33 2.64-2.38 4.91-4.05 4.96z"
        fill={color}
      />
    </Svg>
  )
}
